// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch {
    position: relative;
    display: inline-block;
    width: 53px !important;
    height: 28px !important;
  }
  
  .switch input { 
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
  }
  .modalTrigerButton{
    background: lightgrey;
    border-radius: 14px;
    font-size: 11px;
    color: black;
    font-weight: 600;
    cursor: pointer;
    padding: 6px;
  }
  
  .slider:before {
    position: absolute;
    content: "";
    height: 22px !important;
    width: 22px !important;
    left: 3px !important;
    bottom: 3px;
    background-color: white;
    transition: .4s;
  }
  
  input:checked + .slider {
    background-color: #105293;
  }
  
  input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
  }
  
  input:checked + .slider:before {
    transform: translateX(26px);
  }
  
  .slider.round {
    border-radius: 34px;
  }
  
  .slider.round:before {
    border-radius: 50%;
  }

  .prod_desc{
    font-size: 12px;
    width: 57%;
    font-weight: 500;
    margin-left: 3px;
    display: flex;
    align-self: flex-start;
  }


  .searchDiv{
    border: 1px solid #105293;
  }

  .searchDiv select {
    font-size: 13px;
    font-weight: 600;
    background: #105293;
    color: white;
  }

  .searchDiv input{
    border: none;
    outline: none;
    font-size: 12px;
    
  }

  .btnvar{
    height: 31px !important;
  }

  .filterselection{
    /* border: 1px solid red; */
    border: 1px solid grey;
    border-radius: 10px;
    width: 100%;
    margin-top: 10px;
    background-color: white;
    min-height: 250px;
    position: absolute;
    z-index: 10;
    padding-bottom: 20px;
  }

  .functionalButtons {
    background: lightgrey;
    border-radius: 12px;
    font-size: 12px;
    width: 70px;
    height: 25px;
    cursor: pointer;
    padding-top: 3px;
    color: black;
    font-weight: 700;
    text-align: center;
  }
  
  .functionalButtons:hover{
    background: rgb(122, 121, 121);
  }`, "",{"version":3,"sources":["webpack://./src/pages/catalog/switch.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IAEtB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;IACX,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IAGE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;;EAGA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,eAAe;;EAEjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;EAChC","sourcesContent":[".switch {\n    position: relative;\n    display: inline-block;\n    width: 53px !important;\n    height: 28px !important;\n  }\n  \n  .switch input { \n    opacity: 0;\n    width: 0;\n    height: 0;\n  }\n  \n  .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    -webkit-transition: .4s;\n    transition: .4s;\n  }\n  .modalTrigerButton{\n    background: lightgrey;\n    border-radius: 14px;\n    font-size: 11px;\n    color: black;\n    font-weight: 600;\n    cursor: pointer;\n    padding: 6px;\n  }\n  \n  .slider:before {\n    position: absolute;\n    content: \"\";\n    height: 22px !important;\n    width: 22px !important;\n    left: 3px !important;\n    bottom: 3px;\n    background-color: white;\n    transition: .4s;\n  }\n  \n  input:checked + .slider {\n    background-color: #105293;\n  }\n  \n  input:focus + .slider {\n    box-shadow: 0 0 1px #2196F3;\n  }\n  \n  input:checked + .slider:before {\n    -webkit-transform: translateX(26px);\n    -ms-transform: translateX(26px);\n    transform: translateX(26px);\n  }\n  \n  .slider.round {\n    border-radius: 34px;\n  }\n  \n  .slider.round:before {\n    border-radius: 50%;\n  }\n\n  .prod_desc{\n    font-size: 12px;\n    width: 57%;\n    font-weight: 500;\n    margin-left: 3px;\n    display: flex;\n    align-self: flex-start;\n  }\n\n\n  .searchDiv{\n    border: 1px solid #105293;\n  }\n\n  .searchDiv select {\n    font-size: 13px;\n    font-weight: 600;\n    background: #105293;\n    color: white;\n  }\n\n  .searchDiv input{\n    border: none;\n    outline: none;\n    font-size: 12px;\n    \n  }\n\n  .btnvar{\n    height: 31px !important;\n  }\n\n  .filterselection{\n    /* border: 1px solid red; */\n    border: 1px solid grey;\n    border-radius: 10px;\n    width: 100%;\n    margin-top: 10px;\n    background-color: white;\n    min-height: 250px;\n    position: absolute;\n    z-index: 10;\n    padding-bottom: 20px;\n  }\n\n  .functionalButtons {\n    background: lightgrey;\n    border-radius: 12px;\n    font-size: 12px;\n    width: 70px;\n    height: 25px;\n    cursor: pointer;\n    padding-top: 3px;\n    color: black;\n    font-weight: 700;\n    text-align: center;\n  }\n  \n  .functionalButtons:hover{\n    background: rgb(122, 121, 121);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
